declare namespace $ {

	export class $shm_hitalama_text_table_body extends $mol_grid_table {
		render_visible_only( ): boolean
	}
	
}

//# sourceMappingURL=body.view.tree.d.ts.map